import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Lock, Check, Clock } from 'lucide-react';
export function OfferSection() {
  const valueStack = [{
    name: 'The 4-Week No-Knee Tax Blueprint',
    value: '$47'
  }, {
    name: "The 'Swap-This-For-That' Matrix",
    value: '$29'
  }, {
    name: 'The Anti-Inflammatory Menu',
    value: '$19'
  }, {
    name: "The 'Micro-Dose' Cardio Guide",
    value: '$37'
  }, {
    name: 'Video Form Library Access',
    value: '$47'
  }];
  return <Section id="offer" background="dark" className="pb-32 pt-16" data-id="element-149">
      <div className="max-w-4xl mx-auto" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-950 border-2 border-brand-orange/30 rounded-2xl overflow-hidden shadow-2xl shadow-brand-orange/10 relative" data-id="element-151">
          {/* Urgency Banner */}
          <div className="bg-gradient-to-r from-brand-orange to-orange-600 p-3 text-center flex items-center justify-center gap-2" data-id="element-152">
            <Clock className="w-4 h-4 text-white animate-pulse" data-id="element-153" />
            <p className="text-white font-bold uppercase tracking-widest text-xs md:text-sm" data-id="element-154">
              Limited Time Offer — Save 86% Today
            </p>
          </div>

          <div className="p-6 md:p-12" data-id="element-155">
            <div className="text-center mb-10" data-id="element-156">
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 uppercase" data-id="element-157">
                Joint-Safe Fat Loss
              </h2>
              <p className="text-lg text-slate-400" data-id="element-158">
                The complete protocol for men 50+ to reclaim their physique
                without pain.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 md:gap-12 mb-10 items-center" data-id="element-159">
              {/* Value Stack */}
              <div className="bg-slate-900/50 rounded-xl p-6 border border-slate-800" data-id="element-160">
                <h3 className="text-slate-400 font-bold uppercase text-sm mb-4 tracking-wider" data-id="element-161">
                  What You Get:
                </h3>
                <ul className="space-y-3" data-id="element-162">
                  {valueStack.map((item, i) => <li key={i} className="flex justify-between items-center text-sm border-b border-slate-800 pb-2 last:border-0" data-id="element-163">
                      <div className="flex items-center gap-2" data-id="element-164">
                        <Check className="w-4 h-4 text-green-500" data-id="element-165" />
                        <span className="text-slate-200" data-id="element-166">{item.name}</span>
                      </div>
                      <span className="text-slate-500 font-mono" data-id="element-167">
                        {item.value}
                      </span>
                    </li>)}
                  <li className="flex justify-between items-center pt-2 font-bold text-white text-lg" data-id="element-168">
                    <span data-id="element-169">Total Value</span>
                    <span className="line-through decoration-red-500 decoration-2 text-slate-400" data-id="element-170">
                      $179
                    </span>
                  </li>
                </ul>
              </div>

              {/* Price & CTA */}
              <div className="text-center" data-id="element-171">
                <div className="flex flex-col items-center justify-center mb-6" data-id="element-172">
                  <span className="text-slate-500 text-xl uppercase font-bold mb-2" data-id="element-173">
                    Today's Price
                  </span>
                  <div className="flex items-baseline gap-2" data-id="element-174">
                    <span className="text-slate-500 text-4xl line-through decoration-slate-500/50 decoration-2" data-id="element-175">
                      $47
                    </span>
                    <span className="text-7xl md:text-8xl font-heading font-bold text-brand-orange" data-id="element-176">
                      $6.36
                    </span>
                  </div>
                  <div className="flex flex-col items-center gap-2 mt-3" data-id="element-177">
                    <span className="text-green-500 text-sm font-bold bg-green-500/10 px-3 py-1 rounded-full" data-id="element-178">
                      You Save $40.64
                    </span>
                    <span className="text-slate-500 text-xs uppercase tracking-wide" data-id="element-179">
                      One-time payment
                    </span>
                  </div>
                </div>

                <Button size="xl" fullWidth className="text-xl md:text-2xl py-6 mb-4 shadow-brand-orange/20 shadow-xl animate-pulse hover:animate-none whitespace-nowrap" onClick={() => window.open('https://www.betterbysteps.com/cart/44209345822813:1', '_blank')} data-id="element-180">
                  Get Instant Access Now
                </Button>

                <div className="flex flex-col gap-2 text-xs text-slate-500" data-id="element-181">
                  <div className="flex items-center justify-center gap-2" data-id="element-182">
                    <Lock className="w-3 h-3" data-id="element-183" />
                    <span data-id="element-184">Secure 256-bit SSL Encryption</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-slate-900 rounded-lg p-6 border border-slate-800 text-left relative overflow-hidden" data-id="element-185">
              <div className="absolute top-0 left-0 w-1 h-full bg-green-500" data-id="element-186"></div>
              <div className="flex gap-4 relative z-10" data-id="element-187">
                <div className="bg-green-500/10 p-3 rounded-full h-fit flex-shrink-0" data-id="element-188">
                  <ShieldCheck className="w-8 h-8 text-green-500" data-id="element-189" />
                </div>
                <div data-id="element-190">
                  <h4 className="text-white font-bold text-lg mb-2" data-id="element-191">
                    The "Old Man" Guarantee
                  </h4>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-192">
                    If your joints don't feel better and your belt isn't looser
                    in 30 days, keep the book and get a full refund. No
                    questions asked. We take all the risk so you can focus on
                    the results.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="mt-12 text-center" data-id="element-193">
          
        </div>
      </div>
    </Section>;
}